export default __webpack_public_path__ + "static/media/trekking.747b07ca.jpg";